import React, { useState } from "react";
import styled from "styled-components";
import moment from 'moment';

import { useTheme } from '../../../../Context/ThemeContext';
import { useLanguage } from '../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import UserProfile from "../../../../Component/Normal/UserProfile";

export default function CancelledMemberInfoBox(props) {
  const {
    memberData,
    index,
    onViewUserPhone,
    onClickMemberProfileOrText
  } = props;

  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [isHover, setIsHover] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

  // 호버 시 툴팁 위치 계산 //
  function onMouseEnterInfoWrapper(e) {
    const rect = e.currentTarget.getBoundingClientRect();

    setTooltipPos({ top: rect.top - 20, left: rect.left + 28 });
    setIsHover(true);
  }

  return (
    <InfoWrapper key={'Cancel-' + index} onMouseEnter={onMouseEnterInfoWrapper} onMouseLeave={() => setIsHover(false)}>
      <ImageTooltipWrapper isHover={isHover} top={tooltipPos.top} left={tooltipPos.left}>
        <ImageTooltip>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subBackground} cursor='default'>
            {t('reservation.cancelTime') + moment(memberData.createdDate).format(t('reservation.requestDateFormat'))}
          </Text>
        </ImageTooltip>
        <Triangle />
      </ImageTooltipWrapper>
      <ImageWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
        <UserProfile profile={memberData.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
      </ImageWrapper>
      <MemberDataWrapper>
        <TextWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
          <NameWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{memberData.name}</Text>
          </NameWrapper>
          <PhoneWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{onViewUserPhone(memberData.phone, memberData.countryCode)}</Text>
          </PhoneWrapper>
        </TextWrapper>
      </MemberDataWrapper>
    </InfoWrapper>
  );
}

const InfoWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 96%;
  height: 42px;

  gap: 10px;

  overflow: visible;

  &:hover {
    cursor: pointer;
  }
`;

const ImageTooltipWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  top: ${props => props.top}px;
  left: ${props => props.left}px;

  opacity: ${props => props.isHover ? 1 : 0};

  z-index: ${props => props.isHover ? 1 : -1};

  transition: opacity 0.3s ease-in-out;
`;

const ImageTooltip = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 5px;

  border-radius: 3px;
  background-color:${props => props.theme.primary};
`;

const Triangle = styled.div`
  margin-left: 10px;

  width: 0;
  height: 0;

  border-top: 5px solid ${props => props.theme.primary};
  border-right: 16px solid transparent;
`;

const ImageWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 3px;

  & img {
    width: 42px;
    height: 42px;
    border-radius: 3px;
    object-fit: cover;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MemberDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: calc(100% - 32px);
  height: 42px;

  border-bottom: 1px solid ${props => props.theme.line};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const NameWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PhoneWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
